<eds-panel
  [enableHover]="false"
  [hasBorderRadius]="false"
  [hasBorders]="true"
  [hasPadding]="true"
  [hasShadows]="false"
  [theme]="theme"
>
  <div edsGrid>
    <div edsRow>
      <div edsCol>
        <eds-section-header
          [title]="'products.premium-discount-title' | translate: fundId"
          [asOfDate]="asOfDate"
          [asOfLabel]="'products.as-at' | translate: fundId"
          [level]="3"
          [isLight]="true"
          theme="primary"
          size="h6"
          edsSpacing="md"
          caveatPlacement="Price:PremiumDiscountPrice"
        ></eds-section-header>
      </div>
    </div>
    <div>
      <div edsCssCols edsSubGrid="layout-1" colGap="xxl">
        <eds-info-item
          *ngFor="let item of premiumDiscountData"
          [info]="item"
          edsSpacing="xs"
        ></eds-info-item>
      </div>
    </div>
  </div>
</eds-panel>
